import styled from "styled-components";

export const MyInput = styled.input`
    padding: 0.75rem;
    outline: none;
    border: 0px;
    border-radius: 0.5rem;
    background-color: #f4f6f7;
    width: 100%;
    font-size: 100%;
    box-sizing: border-box;
`